import React, { Fragment } from 'react'
import { getRange } from '../settings/utils';
export default ({ lives, containerWidth, unit }) => {
    const width = unit
    return <Fragment>

        <text x={containerWidth - width * 10 - (unit / 2) * 5}
            y={unit * 3.5} fontSize={unit} className='level'>LIVES: {lives}</text>


        {getRange(lives).map(i => (
            <rect
                className='life'
                rx={unit / 4}
                height={unit}
                width={width}
                y={unit*2.5}
                x={containerWidth - unit - width * (i + 1) - (unit / 2) * i}
                key={i}
            />
        ))}
    </Fragment>
}